import {
  Alert,
  AlertTitle,
  Box,
  Tooltip,
  styled,
  tooltipClasses,
} from "@mui/material";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#8baac9",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#6c9ac7",
    borderRadius: 5,
    padding: "1px",
    margin: 0,
  },
  padding: 0,
  margin: 0,
}));

export const Info = ({ children, show, title, description }) => (
  <CustomTooltip
    followCursor={false}
    sx={{
      width: "264px",
    }}
    TransitionProps={{ timeout: 0 }}
    title={
      show ? (
        <Alert severity="info">
          <AlertTitle>{title}</AlertTitle>
          {description}
        </Alert>
      ) : undefined
    }
  >
    <Box>{children}</Box>
  </CustomTooltip>
);
